<template>
    <section class="">

        <section>
            <BaseRadioButtonGroup :options="yesNo" group="NewDesign" label="Do you have 3D CAD files?"
                v-model="form.fileCad" requires="True" />
        </section>


        <section class="max-h-screen">
            <div v-if="form.fileCad == 'Yes'">
                <FileComponent label="Please upload your CAD file" @uploaded="handleFileUpload" requires="True" />

                <div class="rounded-md bg-blue-50 p-4 mt-3 text-xs text-zinc-500">
                    <slot></slot>
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <InformationCircleIcon class="h-5 w-5 text-blue-400" aria-hidden="true" />
                        </div>
                        <div class="ml-3 flex-1">
                            <p class="text-xs text-dark">
                                For fastest quote processing, we recommend these file types:
                            <ul class="list-disc pl-5 my-2">

                                <li>SolidWorks Pack n Go (containing all .sldprt files)</li>
                                <li>.step (STEP file)</li>
                                <li>.stp (STEP file)</li>
                                <li>.igs (IGES file)</li>
                                <li>.asm (ProE 3D assembly)</li>
                                <li>.x_t (Unigraphics)</li>
                                <li>.sat (AutoCad 3D assembly)</li>
                                <li>.dwg (AutoCad 2D assembly)</li>
                                <li>.dxf (AutoCad 2D assembly)</li>
                                <li>.stl (3D Printing)</li>
                            </ul>
                            </p>


                            <p class="text-xs text-dark">
                                We do not recommend .sldasm files, as we cannot open or view the files without the
                                associated .sldprt files.
                                <br>
                                <br>
                                <span class="text-orange-600">*Have multiple files? Zip your files together and send as a zipped file!</span>
                            </p>

                        </div>
                    </div>
                </div>


                <div class="rounded-md bg-red-50 p-4 mt-3">

                    <div class="flex">
                        <div class="flex-shrink-0">
                            <ExclamationTriangleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                            <p class="text-xs text-red-900">Have multiple files? Zip your files together and upload the
                                zipped file! </p>

                        </div>
                    </div>
                </div>


                <div class="space-y-6 pt-8 sm:space-y-5 sm:pt-10">
                    <div class="my-4">

                        <BaseRadioButtonGroup :options="yesNo" :group="`revisedPart`"
                            label="Is this a new revision to a part we previously quoted?" v-model="form.revisedPart"
                            requires="True" />

                        <div v-if="form.revisedPart == 'Yes'">
                            <BaseInput
                                label="Please indicate the previous quote number or the previous filename, and the revision number:"
                                v-model="form.previousQuoteNumber" requires="True" />
                        </div>

                        <BaseRadioButtonGroup v-if="form.revisedPart == 'No'" :options="yesNo"
                            :group="`similarToPreviouslyOrdered`"
                            label="Is this similar to a part that you've previously ordered?"
                            v-model="form.similarToPreviouslyOrdered" requires="True" />

                        <div v-if="form.similarToPreviouslyOrdered == 'Yes'">
                            <BaseInput label="Please indicate the previous job number that it is similar to:"
                                v-model="form.previousJobNumber" requires="True" />
                        </div>

                        <BaseInput v-if="form.quoteSimilarPartPreviously == 'Yes'"
                            label="Please provide filename of previous design or PO ?"
                            v-model="form.filenamePreviousDesign" />

                        <BaseInput label="Quantity" type="number" min="0" max="100" placeholder="Please enter your number"
                            v-model="form.Quantity" requires="True" />

                    </div>
                </div>

            </div>

            <div v-if="form.fileCad == 'No'">
                <BaseRadioButtonGroup :options="cadSoftware" group="cadSoftware" label="How would you like to proceed?"
                    v-model="form.cadsoftware" requires="True" />

                <div v-show="form.cadsoftware == 'I would like to use your CAD software to design what I need'"
                    class="space-y-6  sm:space-y-5 ">

                    <p class="text-sm font-semibold bg-blue-500 p-3 rounded-md text-blue-100">
                        Awesome! Protocase Designer is our free CAD design
                        software that enables you to design custom electronic enclosures, brackets and panels. No
                        starting from
                        scratch! Get instant quotes and order online when you’re ready.
                    </p>

                    <a href="http://www.protocasedesigner.com"
                        class="block rounded-md w-56 bg-green-600 my-6 text-white p-2" target="_blank"
                        rel="noopener noreferrer">
                        <span class="text-lg font-semibold">Start Protocase Designer</span>
                    </a>


                </div>


                <div>
                    <div v-show="form.cadsoftware == 'I would like help designing what I need'"
                        class="space-y-6  sm:space-y-5 ">
                        <div class="my-6">
                            <p class="text-sm font-semibold bg-blue-500 p-3 rounded-md text-blue-100">
                                Did you know you can generate a free CAD template that you can customize in your own CAD
                                software?
                                Check out the
                                <a class="font-extrabold" href="https://orders.protocase.com/myaccount/">CAD Template
                                    Generator</a>.
                                <br>
                                <br>
                                If you're looking for design assistance, we're happy to help! We offer Design Services a
                                reasonable
                                hourly rate. We can provide you a rough estimate for our design services and the cost to
                                manufacture
                                once you provide us some information about your project.
                            </p>

                        </div>
                        <div class="my-6">
                            <BaseTextArea
                                label="Tell us about the design you need made. On the next section of the form, you will tell us in detail the material and finishes you require."
                                placeholder="Enter your requirements here" v-model="form.designRequirements"
                                requires="True" />
                        </div>
                        <div class="my-6">
                            <div class="space-y-6  sm:space-y-5 ">
                                <!-- Note:Upload a photo, sketch, drawing or datasheet. Please make sure to zip multiple files and upload as one single zipped file. -->
                                <p class="text-sm font-semibold bg-blue-500 p-3 rounded-md text-blue-100">
                                    Upload a photo, sketch, drawing or datasheet. Please make sure to zip multiple files
                                    and upload as
                                    one single zipped file.
                                </p>
                                <FileComponent @uploaded="handleFileUpload" />
                            </div>
                        </div>
                        <div class="my-6">

                            <BaseInput label="Quantity" type="number" min="0" max="100"
                                placeholder="Please enter your number" v-model="form.Quantity" requires="True" />


                            <BaseRadioButtonGroup :options="yesNo" group="designPartComponent"
                                label="Do you have a part or component you can send for our Design Services team to refer to?"
                                v-model="form.designPartComponent" />
                        </div>
                    </div>

                </div>




            </div>
        </section>


    </section>




    <!-- modal to show missing fields -->
    <!-- Show modal popup when fields are missing -->
    <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-10" @close="open = false">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
                leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel
                            class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                            <div>
                                <button @click="open = false" ref="cancelButtonRef" v-if="success == true"
                                    class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                                    <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true" />

                                </button>
                                <button @click="open = false" ref="cancelButtonRef" v-if="success == false"
                                    class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
                                    <XMarkIcon class="h-6 w-6 text-red-600" aria-hidden="true" />

                                </button>

                                <div class="mt-3 text-center sm:mt-5">
                                    <DialogTitle as="p">
                                        <!-- add missing fields -->
                                        <template v-if="success == false">
                                            <p class="font-semibold">
                                                Please fill out the following fields:

                                            </p>
                                            <p v-for="field in missingFields" :key="field"
                                                class="text-xs items-center text-left leading-6 text-red-900">
                                                * {{ field }}
                                            </p>
                                        </template>
                                        <!-- add success message -->
                                        <template v-if="success == true">
                                            <p>
                                                Thank you for your submission. We will be in touch shortly.
                                            </p>
                                        </template>
                                    </DialogTitle>

                                </div>
                            </div>

                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>

    <!-- hide buttons if cadSoftware is I would like to use your CAD software to design what I need -->
    <section v-if="form.cadsoftware != 'I would like to use your CAD software to design what I need'">
        <section class="my-6 flex justify-between">
            <Button label="Back" disabled class="disabled:bg-gray-400" />

            <Button label="Next" class="bg-blue-600 text-white p-2" @click.prevent="checkMissingFields" />

        </section>
    </section>
</template>

<script setup>

import { ref, inject } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { CheckIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/vue/20/solid';

import Button from "./formComponents/Button.vue";
import BaseRadioButtonGroup from "./formComponents/BaseRadioButtonGroup.vue";
import { yesNo, cadSoftware } from "../constants/options";
import FileComponent from "./formComponents/FileComponent.vue";
import BaseInput from "./formComponents/BaseInput.vue";
import BaseTextArea from "./formComponents/BaseTextArea.vue";
import Alert from './formComponents/Alert.vue';

const form = inject('form')

// file upload and store file data as JSON
const handleFileUpload = (file) => {
    form.NewDesignfile = file;
    form.NewDesignfileName = file.name;
}

const missingFields = ref([]);
const success = ref(false);
const open = ref(false);

const checkMissingFields = () => {
    missingFields.value = [];
    if (!form.fileCad) {
        missingFields.value.push('Please select an option')
    }

    if (form.fileCad == 'Yes') {
        if (!form.NewDesignfileName) {
            missingFields.value.push('Please upload your CAD file')
        }
        if (!form.Quantity) {
            missingFields.value.push('Please enter the quantity')
        }

        // revisedPart
        if (!form.revisedPart) {
            missingFields.value.push('Is this a new revision to a part we previously quoted?')
        }

        // previousQuoteNumber
        if (form.revisedPart == 'Yes') {
            if (!form.previousQuoteNumber) {
                missingFields.value.push('Please indicate the previous quote number or the previous filename, and the revision number: ')
            }
        }

        // similarToPreviouslyOrdered 
        if (form.similarToPreviouslyOrdered == 'Yes') {
            if (!form.similarToPreviouslyOrdered) {
                missingFields.value.push("Is this similar to a part that you've previously ordered?")
            }
        }

        // PreviousJobNumber
        if (form.similarToPreviouslyOrdered == 'Yes') {
            if (!form.previousJobNumber) {
                missingFields.value.push('Please indicate the previous job number that it is similar to:')
            }
        }

    }

    if (form.fileCad == 'No') {
        if (!form.cadsoftware) {
            missingFields.value.push('Please select an option')
        }

        if (form.cadsoftware == 'I would like to use your CAD software to design what I need') {
            if (!form.Quantity) {
                missingFields.value.push('Please enter quantity')
            }
        }
        if (form.cadsoftware == 'I would like help designing what I need') {
            if (!form.designRequirements) {
                missingFields.value.push('Please enter design requirements')
            }
        }
    }
    if (missingFields.value.length == 0) {
        form.step = 'materialFinishes';
    } else {
        success.value = false;
        open.value = true;
    }
}

// allowed upload file types


</script>